export default "__VITE_ASSET__DUOmoFwp__"